import React, { Fragment } from 'react'
import * as R from 'ramda'
import Seo from '@components/Seo'
import CaseStudy from '@containers/CaseStudy'

const CaseStudyPage = ({ data }) => {
  const metaTitle = R.pathOr('', ['contentfulPage', 'metaTitle'], data)
  const metaDescription = R.pathOr('', ['contentfulPage', 'metaDescription'], data)
  const canonicalUrl = R.pathOr('', ['contentfulPage', 'canonicalUrl'], data)
  const caseStudy = R.pathOr('', ['contentfulPage', 'template', '0'], data)

  return (
    <Fragment>
      <Seo
        title={metaTitle}
        canonicalUrl={canonicalUrl}
        description={metaDescription}
      />

      {caseStudy && <CaseStudy caseStudy={caseStudy} />}
    </Fragment>
  )
}

export const query = graphql`
query caseStudyQuery($slug: String) {
  contentfulPage(slug: { eq: $slug }) {
    metaTitle
    canonicalUrl
    metaDescription
    template {
      ... on ContentfulCaseStudyTemplate {
        title
        intro {
          intro
        }
        image {
          resize(width:1500) {
            src
          }
        }
        content {
          childMarkdownRemark {
            html
          }
        }
        products {
          ... on ContentfulPage {
            slug
            title
            template {
              ... on ContentfulProductTemplate {
                __typename
                shortName
                category
              }
            }
          }
        }
      }
    }
  }
}
`

export default CaseStudyPage



// WEBPACK FOOTER //
// ./src/templates/case-study.js